// extracted by mini-css-extract-plugin
module.exports = {"content":"Channels_content__28PZw","page-title":"Channels_page-title__19Aea","pageTitle":"Channels_page-title__19Aea"};